import React from "react";

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import { css } from "@emotion/core";
import HashLoader from "react-spinners/HashLoader";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// styles
import {
  TitleModalStyled,
  DetailListStyled,
  ImageContainerStyled,
  ImageStyled,
  ImageRowStyled,
  ImageTitleStyled,
} from "./styles";
import "./styles.css";

// core components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "components/CustomButtons/Button.js";

import { imageOrderDetailType } from "helpers/dictionary";
import { SHIPPER_TRUCK_STACIONARY } from "helpers/generalTypes";
// components

const useStyles = makeStyles(styles);

const override = css`
  display: block;
  margin: 2rem auto;
`;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const OrdersHistoryModals = React.memo(
  ({
    colorRGB,
    modal,
    id,
    itemModal = null,
    isLoading,
    type,
    onCloseModalDetail,
    onPostsale = null,
  }) => {
    const classes = useStyles({ color: colorRGB });

    return (
      <React.Fragment>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal,
          }}
          open={modal}
          transition={Transition}
          keepMounted
          onClose={() => onCloseModalDetail()}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => onCloseModalDetail()}
            >
              <Close className={classes.modalClose} />
            </Button>
            <TitleModalStyled color={colorRGB} className={classes.modalTitle}>
              Detalle de la venta
            </TitleModalStyled>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
          >
            {itemModal && (
              <>
                <DetailListStyled>
                  <li>
                    <strong>Folio: </strong>
                    {itemModal.folio}
                  </li>
                  <li>
                    <strong>Cuenta: </strong>
                    {itemModal.account}
                  </li>
                  <li>
                    <strong>Cliente: </strong>
                    {itemModal.customerName}
                  </li>
                  <li>
                    <strong>Celular: </strong>
                    {itemModal.phone}
                  </li>
                  <li>
                    <strong>Cantidad: </strong>
                    {itemModal.quantity}
                  </li>
                  <li>
                    <strong>Precio unitario: </strong>
                    {itemModal.price ? itemModal.price : ""}
                  </li>
                  <li>
                    <strong>Monto: </strong>
                    {itemModal.amount ? `$${itemModal.amount}` : ""}
                  </li>
                  <li>
                    <strong>Descuento: </strong>
                    {`$${itemModal.discount}`}
                  </li>
                  <li>
                    <strong>Descuento en producto: </strong>
                    {itemModal.discountProduct}
                  </li>
                  <li>
                    <strong>Fecha y hora de Entrega: </strong>
                    {itemModal.delivery}
                  </li>
                  <li>
                    <strong>Dirección: </strong>
                    {itemModal.address}
                  </li>
                  <li>
                    <strong>Unidad: </strong>
                    {itemModal.unit}
                  </li>
                </DetailListStyled>
                <ImageRowStyled>
                  {itemModal.images && (
                    <>
                      {itemModal.images.map((image, index) => (
                        <ImageContainerStyled key={`${image.type}${index}`}>
                          <ImageTitleStyled>
                            <strong>{imageOrderDetailType[image.type]}</strong>
                          </ImageTitleStyled>
                          <ImageStyled src={image.url} alt={image.type} />
                        </ImageContainerStyled>
                      ))}
                    </>
                  )}
                </ImageRowStyled>
              </>
            )}
            {isLoading && (
              <HashLoader
                css={override}
                size={60}
                color={`${colorRGB}`}
                loading={isLoading}
              />
            )}
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            {itemModal &&
              itemModal.images &&
              type === SHIPPER_TRUCK_STACIONARY && (
                <Button
                  onClick={() => onPostsale && onPostsale(id)}
                  color="success"
                >
                  Postventa
                </Button>
              )}
            <Button onClick={() => onCloseModalDetail()} color="info">
              Salir
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
);

export default OrdersHistoryModals;
